import { useMemo } from "react";
import useSessionStore from "../store/useSessionStore";

/**
 * Permite interactuar con la configuracion de usuario
 * @param {*} param0 
 * @returns 
 */
export const useSwitchInstitution = ({
    config,
    returnDefault = false
}) => {
    const { user } = useSessionStore();
    const institution = useMemo(() => {
        const codes = {
            "1232d20c-2e5d-4a91-98ef-a35dcda4cdfb": "FAAQ",
            "235c1c82-aae0-4f4b-a301-bb0c65b6ed5b": "BC"
        };
        return { ...user?.institutionalUser?.subscription?.institution, uniquecode: codes[user?.institutionalUser?.subscription?.institution?.code] ?? "OTHER" };
    }, [user]);
    const _config = useMemo(() => {
        if (institution?.uniquecode in config) return config[institution.uniquecode];
        if (returnDefault) return config["default"];
        return null;
    }, [config, institution,returnDefault]);
    return { config: _config, institution,user }
}
